import React, { useEffect, useState } from "react";
// import { ReactComponent as RequireStarIcon } from "../../../assets/icons/require-star.svg";
import "./Text-input.styles.scss";

export interface TextInputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  variant?: "primary" | "square" | "underline" | "square-small" | "pure";
  textColor?: "gray" | "black" | "deep-green";
  className?: string;
  inputBgc?: string;
  labelClassName?: string;
  errors?: string[];
  isEditActive?: boolean;
  required?: boolean;
}

export const TextInput: React.FC<TextInputProps> = ({
  label = "",
  variant = "primary",
  textColor = "deep-green",
  inputBgc = "#FFFFFF",
  className = "",
  labelClassName = "",
  // isEditActive = false,
  errors = [],
  required = false,
  ...props
}) => {
  const [isErrors, setIsErrors] = useState(false);
  useEffect(() => {
    if (errors.length) {
      setIsErrors(true);
    } else {
      setIsErrors(false);
    }
  }, [errors]);

  return (
    <label className={`text-input-label ${className}`}>
      <span
        hidden={!label}
        className={`text-input__label text-input__label--${variant} ${labelClassName} ${
          required ? "text-input__label-required" : ""
        }`}>
        {label}
      </span>
      {/* {required ? (
        <RequireStarIcon className="text-input__label-required" fill="red" />
      ) : (
        ""
      )} */}
      <input
        {...props}
        style={{ backgroundColor: inputBgc ? inputBgc : "" }}
        className={`text-input text-input--${textColor} text-input--${variant} text-input${
          isErrors ? "--error" : ""
        }`}
      />
      {errors?.length ? (
        <span
          className={`text-input__error text-input__error${
            isErrors ? "--active" : ""
          }`}>
          {errors?.map((item) => item)}
        </span>
      ) : null}
    </label>
  );
};
